import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';

import LocaleService from '@services/LocaleService';
import useTranslation from '@shared/hooks/useTranslation';
import { AccountCreatedIcon } from '@shared/icons';

import './RegisterPageContentStyle.scss';

type AccountCreatedPageProps = {
  registrationType: 'dentist' | 'dental-clinic' | 'laboratory';
};

const AccountCreatedPage = ({ registrationType }: AccountCreatedPageProps) => {
  const i18nRegistration = useTranslation('registration');

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="account-created-container">
      <Row className="mb-5">
        <Col>
          <AccountCreatedIcon />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="b1 mb-2">
            {LocaleService.parseTranslationElement(i18nRegistration.accountCreated.description, {
              // eslint-disable-next-line react/no-unstable-nested-components
              duration: (duration: string) => (
                <span className="duration-label-style">{duration}</span>
              ),
            })}
          </div>
        </Col>
      </Row>
      {registrationType === 'dental-clinic' && (
        <Row className="mt-3">
          <Col>
            <div className="b1 mb-2">
              {LocaleService.parseTranslationElement(i18nRegistration.accountCreated.clinicTrial, {
                // eslint-disable-next-line react/no-unstable-nested-components
                duration: (duration: string) => (
                  <span className="duration-label-style">{duration}</span>
                ),
              })}
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default AccountCreatedPage;
